import { FormControlLabel, Switch } from "@mui/material";
import React, { useEffect, useState } from "react";
import DataCard from "../DataCard";
import FormCard1 from "./FormCard1";
import Level2SubCard from "./SubCard";
import { message } from "antd";
import DyanmicFrom from "../../../DyanmicForm/DyanmicFrom";
import { gettitle } from "../../../../utils/getImages";
import CustomSubmit from "../Custom2StageForm/CustomSubmit";
import PropTypes from "prop-types";
const Level3Card = ({
  error,
  fields,
  page_id,
  updateComponentData,
  preview,
  dataCard,
  setDataCard,
  children,
  oldData,
  level1,
  level2,
  hidepreview,
  slug,
}) => {
  const [active, setActive] = useState(false);

  const [activeSection, setActiveSection] = useState();

  useEffect(() => {
    if (oldData) setDataCard(oldData);
  }, [oldData]);
  useEffect(() => {
    setActive(preview);
  }, [preview]);

  const addData = (index, cardData, type) => {
    let array = [];
    if (type) {
      array = [...dataCard.dataArray];
      array[index] = cardData;
    } else if (dataCard.dataArray) array = [...dataCard.dataArray, cardData];
    else array = [cardData];
    setDataCard({ ...dataCard, dataArray: array });
    if (type) {
      message.success("data updated click on publish to publish changes");
    } else {
      message.success("Created");
    }
  };

  const handleUp = (index) => {
    let arr = dataCard?.dataArray;
    if (index > 0) {
      let val = dataCard?.dataArray[index];
      let val1 = dataCard?.dataArray[index - 1];
      arr[index] = val1;
      arr[index - 1] = val;
      setDataCard({ ...dataCard, dataArray: arr });
    }
  };

  const handleDown = (index) => {
    let arr = dataCard?.dataArray;
    if (index < arr.length - 1) {
      let val = dataCard?.dataArray[index];
      let val1 = dataCard?.dataArray[index + 1];
      arr[index] = val1;
      arr[index + 1] = val;
      setDataCard({ ...dataCard, dataArray: arr });
    }
  };

  const handleChange = (event) => {
    setActive(event.target.checked);
  };

  const handleStatus = (index) => {
    const updatedArray = [...dataCard.dataArray];
    updatedArray[index] = {
      ...updatedArray[index],
      status: !updatedArray[index].status,
    };
    setDataCard({ ...dataCard, dataArray: updatedArray });
  };
  return (
    <div className={!hidepreview && "card"}>
      <div
        style={{
          display: "flex",
          alignItems: "flex-end",
          justifyContent: "flex-end",
        }}
      >
        {" "}
        {!hidepreview && (
          <FormControlLabel
            control={<Switch checked={active} onChange={handleChange} />}
            label="Preview"
          />
        )}
      </div>
      {active && children}

      {!active && (
        <div className="card-body">
          <div className="row">
            <DyanmicFrom
              error={error}
              attributes={fields || []}
              data={dataCard}
              level={1}
              setData={(e) => {
                setDataCard(e);
              }}
            />
          </div>
          {dataCard?.dataArray?.map((item, index) => (
            <DataCard
              key={index + ""}
              handleup={handleUp}
              handledown={handleDown}
              handleStatus={handleStatus}
              title={gettitle(item, slug)}
              index={index}
              activeDrop={activeSection}
              setActiveDrop={setActiveSection}
              array={dataCard?.dataArray}
              slug={slug}
              setArray={(e) => {
                setDataCard({ ...dataCard, dataArray: e });
              }}
            >
              <FormCard1
                active={activeSection === index}
                attributes={level1}
                data={item}
                updateData={(index, cardData, type) => {
                  addData(
                    index,
                    { ...cardData, dataArray: item?.dataArray },
                    type
                  );
                }}
                index={index + 1}
              />

              <Level2SubCard
                slug={slug}
                item={item}
                index={index}
                attributes={level2}
                key={index + ""}
                dataCard={dataCard?.dataArray?.[index] || { dataArray: [] }}
                setDataCard={(item) => {
                  let arr = dataCard?.dataArray || [];
                  arr[index] = item;
                  setDataCard({
                    ...dataCard,
                    dataArray: arr,
                  });
                }}
              />
            </DataCard>
          ))}
          <FormCard1 add updateData={addData} />
          {page_id && (
            <CustomSubmit
              data1={dataCard}
              data2={oldData}
              handleSubmit={() => updateComponentData(dataCard)}
            />
          )}
        </div>
      )}
    </div>
  );
};
Level3Card.propTypes = {
  error: PropTypes.any,
  fields: PropTypes.any,
  page_id: PropTypes.any,
  updateComponentData: PropTypes.any,
  preview: PropTypes.any,
  dataCard: PropTypes.any,
  setDataCard: PropTypes.any,
  children: PropTypes.any,
  oldData: PropTypes.any,
  level1: PropTypes.any,
  level2: PropTypes.any,
  hidepreview: PropTypes.any,
};

export default Level3Card;
